import { useContext } from 'react';
import { CalculatorContext } from 'contexts/CalculatorContext';

export const useCalculator = () => useContext(CalculatorContext);
